import FindRecipientPersonaType from '../store/schema/FindRecipientPersonaType';

export default function getDisplayNameFromFindRecipientPersonaType(
    findRecipient: FindRecipientPersonaType
): string {
    return findRecipient.EmailAddress.Name || findRecipient.DisplayName;
}
